export default ['$compile', 'contentTemplatesService', directive]

function directive($compile, contentTemplatesService) {
  return {
    require: '^composeBody',
    replace: true,
    restrict: 'E',
    scope: {
      feature: '=',
    },
    link: function($scope, element, attrs, controller) {
      const { type } = $scope.feature
      const template = contentTemplatesService.getProperties(type)
      if (template) {
        element.append(
          $compile(template)($scope, null, {
            // Pass composeBody controller ref down
            transcludeControllers: {
              composeBody: { instance: controller },
            },
          })
        )
      }
    },
    controller: [
      '$scope',
      function($scope, $element) {
        $scope.correctionTypes = ['correction', 'clarification']
      },
    ],
  }
}
